import { useState } from "react";
export const useResultState = () => {
  const [results, setResults] = useState([]);
  const [errors, setErrors] = useState(null);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState("all");
  const [competitions, setCompetitions] = useState([]);
  const [selectedCompetitionId, setSelectedCompetitionId] = useState("all");
  const [season, setSeason] = useState("2025");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [groupedResults, setGroupedResults] = useState({});

  return {
    results,
    setResults,
    errors,
    setErrors,
    loading,
    setLoading,
    filter,
    setFilter,
    competitions,
    setCompetitions,
    selectedCompetitionId,
    setSelectedCompetitionId,
    season,
    setSeason,
    fromDate,
    setFromDate,
    toDate,
    setToDate,
    searchTerm,
    setSearchTerm,
    groupedResults,
    setGroupedResults,
  };
};
